import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import PropTypes from "prop-types";
import Modal from "../../../../parts/modal-new";

const RateMealPlanModal = ({ locals }) => {
  const { t } = useTranslation("coaching-portal");
  const { query } = locals || {};
  const { mealPlan: mealPlanId } = query || {};

  const [rating, setRating] = useState(null);
  const [feedback, setFeedback] = useState("");

  const handleRatingClick = (value) => {
    setRating(value);
  };

  const handleFeedbackChange = (e) => {
    setFeedback(e.target.value);
  };

  const handleCancel = () => {
    submit("/actions/refresh?", {
      method: "GET",
      body: { "modal[type]": "" },
    });
  };

  const handleSubmit = () => {
    if (!rating) {
      return;
    }

    if (!feedback.trim()) {
      return;
    }

    const body = {
      mealPlanId,
      rating,
      feedback: feedback.trim(),
    };
    
    console.log("Rate Meal Plan Data:", body);

    submit(`/actions/meal-planner/meal-plan-review`, {
      method: "POST",
      body,
    });
  };

  return (
    <Modal
      className="rate-meal-plan-modal"
      title={t("editMealPlan.rateMealPlanModal.title")}
      toClear={[]}
    >
      <div className="body">
        <div className="rating-section">
          <p className="rating-question">
            {t("editMealPlan.rateMealPlanModal.ratingQuestion")}
          </p>
          <div className="rating-buttons">
            {Array.from({ length: 10 }, (_, i) => i + 1).map((value) => (
              <button
                key={value}
                type="button"
                className={`rating-button ${rating === value ? "selected" : ""}`}
                onClick={() => handleRatingClick(value)}
              >
                {value}
              </button>
            ))}
          </div>
          <div className="rating-labels">
            <span className="label-poor">{t("editMealPlan.rateMealPlanModal.poor")}</span>
            <span className="label-excellent">{t("editMealPlan.rateMealPlanModal.excellent")}</span>
          </div>
        </div>

        <div className="feedback-section">
          <p className="feedback-prompt">{t("editMealPlan.rateMealPlanModal.tellUsMore")}</p>
          <textarea
            className="feedback-textarea"
            placeholder={t("editMealPlan.rateMealPlanModal.feedbackPlaceholder")}
            value={feedback}
            onChange={handleFeedbackChange}
            rows={5}
          />
        </div>
      </div>

      <footer>
        <button
          type="button"
          data-button-type="secondary"
          onClick={handleCancel}
          className="cancel-button"
        >
          {t("editMealPlan.rateMealPlanModal.cancel")}
        </button>
        <button
          type="button"
          data-button-type="primary"
          onClick={handleSubmit}
          disabled={!rating || !feedback.trim()}
          className="submit-button"
        >
          {t("editMealPlan.rateMealPlanModal.submit")}
        </button>
      </footer>
    </Modal>
  );
};

RateMealPlanModal.propTypes = {
  locals: PropTypes.object,
};

export default RateMealPlanModal;
